"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserPublicKey = exports.UserSecretKey = exports.USER_PUBKEY_LENGTH = exports.USER_SEED_LENGTH = void 0;
const ed = __importStar(require("@noble/ed25519"));
const sha512_1 = require("@noble/hashes/sha512");
const assertions_1 = require("./assertions");
const pem_1 = require("./pem");
const userAddress_1 = require("./userAddress");
exports.USER_SEED_LENGTH = 32;
exports.USER_PUBKEY_LENGTH = 32;
// See: https://github.com/paulmillr/noble-ed25519
// In a future version of sdk-wallet, we'll switch to using the async functions of noble-ed25519.
ed.utils.sha512Sync = (...m) => sha512_1.sha512(ed.utils.concatBytes(...m));
class UserSecretKey {
    constructor(buffer) {
        assertions_1.guardLength(buffer, exports.USER_SEED_LENGTH);
        this.buffer = Buffer.from(buffer);
    }
    static fromString(value) {
        assertions_1.guardLength(value, exports.USER_SEED_LENGTH * 2);
        const buffer = Buffer.from(value, "hex");
        return new UserSecretKey(buffer);
    }
    static fromPem(text, index = 0) {
        return pem_1.parseUserKey(text, index);
    }
    generatePublicKey() {
        const buffer = ed.sync.getPublicKey(new Uint8Array(this.buffer));
        return new UserPublicKey(buffer);
    }
    sign(message) {
        const signature = ed.sync.sign(new Uint8Array(message), new Uint8Array(this.buffer));
        return Buffer.from(signature);
    }
    hex() {
        return this.buffer.toString("hex");
    }
    valueOf() {
        return this.buffer;
    }
}
exports.UserSecretKey = UserSecretKey;
class UserPublicKey {
    constructor(buffer) {
        assertions_1.guardLength(buffer, exports.USER_PUBKEY_LENGTH);
        this.buffer = Buffer.from(buffer);
    }
    verify(data, signature) {
        try {
            const ok = ed.sync.verify(new Uint8Array(signature), new Uint8Array(data), new Uint8Array(this.buffer));
            return ok;
        }
        catch (err) {
            console.error(err);
            return false;
        }
    }
    hex() {
        return this.buffer.toString("hex");
    }
    toAddress() {
        return new userAddress_1.UserAddress(this.buffer);
    }
    valueOf() {
        return this.buffer;
    }
}
exports.UserPublicKey = UserPublicKey;
//# sourceMappingURL=userKeys.js.map